import { GetApiV1ThreeLetterCodeClientAdminsBranches200 } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import { BranchListPresentation } from '../../presentations';

type Args = {
  data: GetApiV1ThreeLetterCodeClientAdminsBranches200;
};
type IConvertToBranchListProps = (args: Args) => {
  branches: React.ComponentProps<typeof BranchListPresentation>['branches'];
};

export const convertToBranchListProps: IConvertToBranchListProps = ({ data }) => ({
  branches: [...data.branches]
    .sort((a, b) => b.created_at - a.created_at)
    .map(branch => ({
      id: branch.id.toString(),
      name: branch.name,
      code: branch.code,
      createdAtLabel: formatDate({
        date: new Date(branch.created_at * 1000),
        formatType: 'yyyy/M/d H:mm',
      }),
      updatedAtLabel: formatDate({
        date: new Date(branch.updated_at * 1000),
        formatType: 'yyyy/M/d H:mm',
      }),
    })),
});
